module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/life_coop_2-acc86abdf7fdaa0f4c062c0483d9624a.gif";